import { Question } from "@/services/api_question";
import "./index.less";
import ChangeIcon from "@/assets/common/ic_change.svg?react";
import ChatStore from "@/store/chat.store";
import { Skeleton } from "antd";

interface GuessModelProps {
  className?: string;
  questionList: Question[];
  showCount?: number;
  onChooseQuestion?: (question: string) => void;
}

const GuessModel = (props: GuessModelProps) => {
  const { className, showCount, questionList, onChooseQuestion } = props;

  // 直接引用了，不传props了
  const changeQuestion = () => {
    ChatStore.getState().getQuestions(false);
  };

  const handleChooseQuestion = (question: string) => {
    onChooseQuestion?.(question);
  };

  return (
    <div className={`guess-model ${className}`}>
      <div className="guess-header">
        <div className="guess-header-left">💡 猜你想问</div>
        <div className="guess-header-right" onClick={changeQuestion}>
          换一换
          <ChangeIcon className="change-icon" />
        </div>
      </div>
      <div className="guess-list">
        {
          // 如果questionList为空，显示加载中
          questionList.length === 0 && <div>
            <Skeleton.Input active block={true} size="small" className="h-7.5" />
            <Skeleton.Input active block={true} size="small" className="h-7.5" />
            <Skeleton.Input active block={true} size="small" className="h-7.5" />
          </div>
        }
        {showCount
          ? questionList.slice(0, showCount).map((item) => (
            <div className="guess-list-item" key={item.content} onClick={() => handleChooseQuestion(item.content)}>
              {item.content}
            </div>
          ))
          : questionList.map((item) => (
            <div className="guess-list-item" key={item.content} onClick={() => handleChooseQuestion(item.content)}>
              {item.content}
            </div>
          ))}
      </div>
    </div>
  );
};

export default GuessModel;
